export async function openWithProtocol(
  protocol: string,
  timeoutMs = 1200
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';

    const checkBlur = () => {
      clearTimeout(timeout);
      window.removeEventListener('blur', checkBlur);
      document.body.removeChild(iframe);
      resolve(true);
    };

    const timeout = setTimeout(() => {
      window.removeEventListener('blur', checkBlur);
      document.body.removeChild(iframe);
      resolve(false);
    }, timeoutMs);

    try {
      iframe.src = protocol;
      document.body.appendChild(iframe);
    } catch (err) {
      clearTimeout(timeout);
      document.body.removeChild(iframe);
      resolve(false);
      return;
    }

    window.addEventListener('blur', checkBlur, { once: true });
  });
}
